<div class="dashboard-container">
  <h1>Dashboard</h1>

  <div class="tbl-bar">
    <span class="tbl-left"></span>
    <span class="tbl-right">
      <button mat-raised-button color="primary" (click)="reload()">
        <mat-icon>refresh</mat-icon>
      </button>
    </span>
  </div>

  <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8 full-width-table">

    <ng-container matColumnDef="accountName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Account</th>
      <td mat-cell *matCellDef="let row">{{ row.accountName }}</td>
    </ng-container>

    <ng-container matColumnDef="assetId">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Asset ID</th>
      <td mat-cell *matCellDef="let row">
        <a class="graph-link"
          href="javascript:void(0)"
          (click)="openCharts(row.hostId)"
          matTooltip="View graphs in Zabbix">
           {{ row.assetId }}
        </a>
      </td>
    </ng-container>

    <ng-container matColumnDef="openProblems">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Open Problems</th>
      <td mat-cell [ngClass]="{ 'has-problems': row.openProblems > 0 }" *matCellDef="let row">
        <a href="javascript:void(0)"
          (click)="openProblems(row.hostId)"
          matTooltip="View open problems in Zabbix"
          [class.problem-link]="row.openProblems > 0">
          {{ row.openProblems }}
        </a>
      </td>
    </ng-container>

    <ng-container matColumnDef="newestProblem">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Newest</th>
      <td mat-cell *matCellDef="let row">{{ toDate(row.newestProblem)| date:'short' }}</td>
    </ng-container>

    <ng-container matColumnDef="oldestProblem">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Oldest</th>
      <td mat-cell *matCellDef="let row">{{ toDate(row.oldestProblem) | date:'short' }}</td>
    </ng-container>

    <ng-container matColumnDef="lastSyncTs">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Last Sync</th>
      <td mat-cell *matCellDef="let row" [ngClass]="isOld(row.lastSyncTs) ? 'sync-old' : 'sync-recent'">{{ toDateTs(row.lastSyncTs) | date:'short' }}</td>
    </ng-container>

    <ng-container matColumnDef="stewardVersion">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Steward</th>
      <td mat-cell *matCellDef="let row">{{ row.stewardVersion }}</td>
    </ng-container>

    <ng-container matColumnDef="osVersion">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>OS</th>
      <td mat-cell *matCellDef="let row">{{ row.osVersion }}</td>
    </ng-container>

    <ng-container matColumnDef="pluginVersion">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Plugin</th>
      <td mat-cell *matCellDef="let row">{{ row.pluginVersion }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

  </table>

</div>
